import { useState } from "react";
import { reportCategories } from "../../data/reportCategories";

export default function StepCategory({ onNext, onBack, formData }) {
  const [category, setCategory] = useState(formData.category || "");

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Select Main Category</h2>
      <select
        className="w-full p-2 border rounded mb-4"
        value={category}
        onChange={e => setCategory(e.target.value)}
      >
        <option value="">Select a category...</option>
        {reportCategories.map(cat => (
          <option key={cat.name} value={cat.name}>{cat.name}</option>
        ))}
      </select>
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button
          className="btn btn-primary"
          disabled={!category}
          onClick={() => onNext({ category })}
        >
          Next
        </button>
      </div>
    </div>
  );
}